export default __webpack_public_path__ + "components/forecast-table/static/freezing-graph_backdrop-b12c8eefc0fbe0b23c92162d5f4974ba.jpg";